module.exports = __webpack_public_path__ + "img/img8.e645f8a4.jpg";